import { ODDS_FORMAT, type OddsFormat } from '@cx-web/domain-types';

export const getOddsFormatIs = (userOddsFormat: OddsFormat) => ({
  American: userOddsFormat === ODDS_FORMAT.AMERICAN,
  Decimal: userOddsFormat === ODDS_FORMAT.DECIMAL,
  Fractional: userOddsFormat === ODDS_FORMAT.FRACTIONAL,
});

export const convertAmericanToFractional = (oddsAmerican: string): string => {
  const oddsDecimal = convertAmericanToDecimal(oddsAmerican);

  return convertDecimalOddsToFractional(oddsDecimal);
};

export const convertAmericanToDecimal = (oddsAmerican: string): number => {
  const numericalValue = Number(oddsAmerican);
  const decimal = numericalValue >= 0 ? 1 + numericalValue / 100 : 1 - 100 / numericalValue;
  const fixedDecimal = decimal.toFixed(4);

  return Number(fixedDecimal);
};

export const convertFractionalToAmerican = (oddsFractional: string): string => {
  const oddsDecimal = convertFractionalToDecimal(oddsFractional);

  return convertDecimalToAmerican(oddsDecimal);
};

export const convertFractionalToDecimal = (fractionalOdds: string): number => {
  const fractionParts = fractionalOdds.split('/');
  if (fractionParts.length < 2) return 0;

  const decimal = Number(fractionParts[0]) / Number(fractionParts[1]) + 1;
  const fixedDecimal = (Math.round(decimal * 100) / 100).toFixed(2);

  return Number(fixedDecimal);
};

export const convertDecimalToAmerican = (oddsDecimal: number): string => {
  let convertedOddsToUS;
  if (oddsDecimal >= 2) {
    convertedOddsToUS = (oddsDecimal - 1) * 100;
    return `${convertedOddsToUS.toFixed(0)}`;
  }

  convertedOddsToUS = -100 / (oddsDecimal - 1);
  return convertedOddsToUS.toFixed(0);
};

export const convertDecimalOddsToFractional = (oddsDecimal: number): string => {
  if (oddsDecimal > 3) {
    return `${Math.floor(oddsDecimal - 1)}/1`;
  }
  const reduce = (numerator: number, denominator: number) => {
    // euclidean GCD — relic from legacy
    const gcd = (a: number, b: number): number => (b ? gcd(b, a % b) : a);
    const divisor = gcd(numerator, denominator);
    return [numerator / divisor, denominator / divisor];
  };
  const temp: number = oddsDecimal - 1;
  const number = Number((Number(temp.toFixed(2)) * 100).toFixed(2));
  const simplestForm = reduce(number, 100);

  if (simplestForm.length < 2) {
    return '';
  }

  return `${simplestForm[0]}/${simplestForm[1]}`;
};
